import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { addOfficeStatus } from "../../../../../actions/Utilities/OfficeStatus";
import { toast } from "../../../../../components/toastNotification";
import { OfficeStatusType } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { addStateOfficeStatus, officeStatusReFetching } from "../atoms/atoms";

export default function useAddOfficeStatus() {
  const setIsAddState = useSetRecoilState(addStateOfficeStatus);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusReFetching
  );

  const { mutate } = useMutation(
    (NewData: OfficeStatusType) => addOfficeStatus(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Office Status failed", res.Message, "error");
        } else {
          switch (true) {
            case res =="Success":
              toast.fire(
                "Success",
                "Office Status Added Successfully",
                "success"
              );
              break;
              case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Office Status Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res.includes("Operation Failed!"):
              toast.fire(
                "Adding Office Status failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res.includes ("The data already exists!"):
              toast.fire(
                "Adding Office Status failed",
                `Duplication Error: ${res}`,
                "error"
              );
                break;
            case res.includes("Action object is null!"):
                toast.fire(
                    "Adding Office Status failed",
                    `Error: ${res}`,
                    "error"
                );
              break;
            default:
              toast.fire("Adding Office Status failed", res.Message, "error");
          }
        }
          // Redirect to View
          setIsAddState(false);
          
          // ReFetch Data
          setIsReFetching(isReFetching ? false : true);
        },

        onError: (error: any) => {
          toast.fire("Add Office Status failed", `Error: ${error}`, "error");
        },
      }
  );

  return mutate;
}
